import UserService from '@/services/user.service';

const initialState =
    {
        widgets: []
    };

export const dashboard = {
    namespaced: true,
    state: initialState,
    actions: {},
    setters: {},
    mutations: {
        setWidgets(state, value) {
            state.widgets = value;
            UserService.setWidgets(value).then(
                () => {

                },
                error => {
                    console.log("Error: " + error);
                }
            );
        },
    }
};
